// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1-4Hn","fileBtn":"File_fileBtn__148_r","closeBtn":"File_closeBtn__gqE2q","fileSelected":"File_fileSelected__2oyHp","disabled":"File_disabled__3j-rV"};